const keySizes = {
  '': '@1x',
  '-mobile': 'mobile@1x',
  '-mobile@2x': 'mobile@2x',
  '-mobile@3x': 'mobile@3x'
}

/* eslint-disable max-params */
const getImagesSizes = (image, ext, sizes, requireFn) => {
  return sizes.reduce((acc, size) => {
    try {
      return {
        ...acc,
        [keySizes[size] || size]: requireFn(`${image}${size}.${ext}`)?.default
          ?.src
      }
    } catch (err) {
      return acc
    }
  }, {})
}

const requireImages = (
  images,
  {
    extensions = ['webp', 'png', 'gif'],
    sizes = [
      '',
      '@2x',
      '@3x',
      '-mobile',
      '-mobile@2x',
      '-mobile@3x',
      '-wide',
      '-wide@2x',
      '-wide@3x'
    ],
    requireFn
  }
) => {
  return images.reduce(
    (acc, image) => ({
      ...acc,
      [image]: extensions.map(ext => ({
        ext,
        images: getImagesSizes(image, ext, sizes, requireFn)
      }))
    }),
    {}
  )
}

export default requireImages
